import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, Transition as _Transition, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "initial-loading-box"
}
const _hoisted_2 = {
  key: 1,
  class: "reservation-loading-overlay"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, "Ihre Reservierung wird durchgeführt ...", -1)
const _hoisted_4 = { class: "container" }
const _hoisted_5 = {
  key: 0,
  class: "row"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 mb-md-4 mt-2 mt-md-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Schritt 1: Wunschkennzeichen finden"),
  /*#__PURE__*/_createElementVNode("p", null, "Finden Sie schnell und zuverlässig ein verfügbares Kennzeichen!")
], -1)
const _hoisted_7 = { class: "col-12 col-lg-7 offset" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", null, "Sucheingabe", -1)
const _hoisted_9 = {
  key: 0,
  class: "d-flex justify-content-end align-items-center mt-4 mb-4"
}
const _hoisted_10 = ["disabled"]
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Jetzt Bestellen ")
const _hoisted_12 = {
  key: 1,
  class: "d-flex flex-wrap flex-lg-nowrap justify-content-center justify-content-md-between align-items-center mt-4 mb-4"
}
const _hoisted_13 = ["disabled"]
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Verfügbarkeit Prüfen ")
const _hoisted_15 = /*#__PURE__*/_createElementVNode("strong", null, "Hinweis", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Bitte beachten Sie folgende Punkte bei der Auswahl ihres Wunschkennzeichens: ")
const _hoisted_18 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, " Verwenden Sie keine Buchstaben, die nicht zur Verfügung stehen, wie z.B. Ä, Ö oder Ü. "),
  /*#__PURE__*/_createElementVNode("li", null, " Verwenden Sie keine Kombinationen, die nationalsozialistische Umlaute wie HJ, KZ, NS, SA, SS oder IS enthalten. "),
  /*#__PURE__*/_createElementVNode("li", null, " Vermeiden Sie Kombinationen, die gegen die guten Sitten verstoßen oder möglicherweise beleidigend oder anstößig sind. "),
  /*#__PURE__*/_createElementVNode("li", null, " Stellen Sie sicher, dass das Kennzeichen den Vorschriften des jeweiligen Bundeslandes entspricht. ")
], -1)
const _hoisted_19 = { class: "col-12 col-lg-4 offset-lg-1 mt-4 mt-lg-0" }
const _hoisted_20 = { class: "plate-options mb-4 pb-2" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h3", null, "Kennzeichen", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "bold" }, "Fahrzeug - Typ", -1)
const _hoisted_23 = ["value", "textContent"]
const _hoisted_24 = ["value", "textContent"]
const _hoisted_25 = ["value", "textContent"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "bold" }, "Kennzeichen - Typ", -1)
const _hoisted_27 = ["value"]
const _hoisted_28 = ["value"]
const _hoisted_29 = ["value"]
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "col-12 col-md-6" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "label" }, "von", -1)
const _hoisted_34 = ["textContent"]
const _hoisted_35 = ["textContent"]
const _hoisted_36 = ["textContent"]
const _hoisted_37 = ["textContent"]
const _hoisted_38 = ["textContent"]
const _hoisted_39 = ["textContent"]
const _hoisted_40 = ["textContent"]
const _hoisted_41 = ["textContent"]
const _hoisted_42 = ["textContent"]
const _hoisted_43 = ["textContent"]
const _hoisted_44 = ["textContent"]
const _hoisted_45 = ["textContent"]
const _hoisted_46 = { class: "col-12 col-md-6" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "label" }, "bis", -1)
const _hoisted_48 = ["textContent"]
const _hoisted_49 = ["textContent"]
const _hoisted_50 = ["textContent"]
const _hoisted_51 = ["textContent"]
const _hoisted_52 = ["textContent"]
const _hoisted_53 = ["textContent"]
const _hoisted_54 = ["textContent"]
const _hoisted_55 = ["textContent"]
const _hoisted_56 = ["textContent"]
const _hoisted_57 = ["textContent"]
const _hoisted_58 = ["textContent"]
const _hoisted_59 = ["textContent"]
const _hoisted_60 = /*#__PURE__*/_createElementVNode("h3", null, "Verlauf", -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("strong", null, "Hinweis", -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_63 = /*#__PURE__*/_createTextVNode(" Bitte beachten Sie folgende Punkte bei der Auswahl ihres Wunschkennzeichens: ")
const _hoisted_64 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, " Verwenden Sie keine Buchstaben, die nicht zur Verfügung stehen, wie z.B. Ä, Ö oder Ü. "),
  /*#__PURE__*/_createElementVNode("li", null, " Verwenden Sie keine Kombinationen, die nationalsozialistische Umlaute wie HJ, KZ, NS, SA, SS oder IS enthalten. "),
  /*#__PURE__*/_createElementVNode("li", null, " Vermeiden Sie Kombinationen, die gegen die guten Sitten verstoßen oder möglicherweise beleidigend oder anstößig sind. "),
  /*#__PURE__*/_createElementVNode("li", null, " Stellen Sie sicher, dass das Kennzeichen den Vorschriften des jeweiligen Bundeslandes entspricht. ")
], -1)
const _hoisted_65 = {
  key: 0,
  class: "row"
}
const _hoisted_66 = { class: "offset-md-1 col-12 col-md-10 mb-4 mt-4" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Schritt 2: Daten eingeben", -1)
const _hoisted_68 = { key: 0 }
const _hoisted_69 = { key: 1 }
const _hoisted_70 = { class: "d-flex justify-content-center mb-3 mt-3" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("strong", null, "Hinweis", -1)
const _hoisted_72 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_73 = /*#__PURE__*/_createTextVNode(" Bitte geben Sie hier ihre Daten ein. Die Daten werden sowohl für die Zulassungsstelle als auch für die Lieferung verwendet. ")
const _hoisted_74 = /*#__PURE__*/_createElementVNode("strong", null, "Hinweis", -1)
const _hoisted_75 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_76 = /*#__PURE__*/_createTextVNode(" Bitte geben Sie hier ihre Daten ein. Die Daten werden nur für die Lieferung verwendet. ")
const _hoisted_77 = { class: "bottom-row" }
const _hoisted_78 = { class: "offset-md-1 col-12 col-md-10" }
const _hoisted_79 = { class: "d-flex flex-column flex-md-row justify-content-between" }
const _hoisted_80 = ["disabled"]
const _hoisted_81 = /*#__PURE__*/_createTextVNode(" Zum Bezahlvorgang ")
const _hoisted_82 = {
  key: 0,
  class: "row"
}
const _hoisted_83 = { class: "offset-md-1 col-12 col-md-10 mb-4 mt-4 position-relative" }
const _hoisted_84 = {
  key: 0,
  class: "title"
}
const _hoisted_85 = {
  key: 1,
  class: "title"
}
const _hoisted_86 = { key: 2 }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("strong", null, "selben Tag", -1)
const _hoisted_88 = /*#__PURE__*/_createTextVNode("! ")
const _hoisted_89 = { key: 3 }
const _hoisted_90 = /*#__PURE__*/_createTextVNode(" Ihr Wunschkennzeichen wird nicht reserviert. Der Versand erfolgt noch am ")
const _hoisted_91 = /*#__PURE__*/_createElementVNode("strong", null, "selben Tag", -1)
const _hoisted_92 = /*#__PURE__*/_createTextVNode("! ")
const _hoisted_93 = [
  _hoisted_90,
  _hoisted_91,
  _hoisted_92
]
const _hoisted_94 = { class: "d-flex justify-content-center mb-3 mt-3" }
const _hoisted_95 = /*#__PURE__*/_createElementVNode("div", { class: "subtitle" }, "Ihre Bestellung", -1)
const _hoisted_96 = /*#__PURE__*/_createElementVNode("div", { class: "subtitle mt-4" }, "Ihre Daten", -1)
const _hoisted_97 = { class: "d-flex justify-content-start align-items-start mt-2" }
const _hoisted_98 = /*#__PURE__*/_createElementVNode("strong", null, "Hinweis", -1)
const _hoisted_99 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_100 = /*#__PURE__*/_createTextVNode(" Mit Ihrer Bestellung erklären Sie sich mit unseren ")
const _hoisted_101 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.wunschkennzeichen.de/agb",
  target: "_blank"
}, "AGB's", -1)
const _hoisted_102 = /*#__PURE__*/_createTextVNode(", ")
const _hoisted_103 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.wunschkennzeichen.de/datenschutz",
  target: "_blank"
}, "Datenschutzbestimmungen", -1)
const _hoisted_104 = /*#__PURE__*/_createTextVNode(" , sowie den ")
const _hoisted_105 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.wunschkennzeichen.de/widerrufsbelehrung",
  target: "_blank"
}, "Widerrufsbelehrung", -1)
const _hoisted_106 = /*#__PURE__*/_createTextVNode(" einverstanden. ")
const _hoisted_107 = /*#__PURE__*/_createElementVNode("div", { class: "bottom-row white" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "offset-md-1 col-12 col-md-10" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center flex-column align-items-center" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "title mb-4" }, "Jetzt kostenpflichtig bestellen"),
      /*#__PURE__*/_createElementVNode("div", { id: "paypal-button" })
    ])
  ])
], -1)
const _hoisted_108 = { class: "pb-1" }
const _hoisted_109 = { class: "container" }

import type { Axios } from 'axios';
import dayjs from 'dayjs';
import { loadScript, PayPalNamespace } from '@paypal/paypal-js';

// vue
import { useRoute } from 'vue-router';
import { inject, onMounted, ref, computed, getCurrentInstance } from 'vue';

// types
import {
  ILicenseOffice,
  ISearchResult,
  IAvailabilityResponse,
  IUserData,
  EPlateType,
  MonthNameMap,
  IOrderData,
  ECarType,
  CarTypeMap,
} from '@/classes/interfaces/data';

// vue components
import StepHeader from '@/components/StepHeader.vue';
import StepBox from '@/components/StepBox.vue';
import LicenseInput from '@/components/LicenseInput.vue';
import InfoBox from '@/components/InfoBox.vue';
import SearchHistory from '@/components/SearchHistory.vue';
import CustomerDataInput from '@/components/CustomerDataInput.vue';
import LicenseDisplay from '@/components/LicenseDisplay.vue';
import Checkbox from '@/components/Checkbox.vue';
import CostTable from '@/components/CostTable.vue';
import UserDataTable from '@/components/UserDataTable.vue';
import CopyText from '@/components/CopyText.vue';
import LocationBanner from '@/components/Location/LocationBanner.vue';

// animations
import LoadingAnimation from '@/assets/animations/home-animation-1.json';
import ReservationAnimation from '@/assets/animations/animation-reservation-loading.json';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

// node modules
const DEBUG_ACTIVE = process.env.NODE_ENV === 'development';

const AxiosClient = inject('axios') as Axios;

const LoadingActive = ref<boolean>(true);
const PaypalLoadingActive = ref<boolean>(false);
const ActiveStep = ref<number>(1);
const Office = ref<ILicenseOffice>();
const History = ref<ISearchResult[]>([]);
const SelectedLicense = ref<ISearchResult>();
const Code1 = useRoute().params.code as string;
const Code2 = ref<string>('');
const Code3 = ref<string>('');
const OrderID = ref<string>('');
const StepElement = ref<HTMLElement>();
const LicenseInputElement = ref<InstanceType<typeof LicenseInput> | null>(null);

const SearchHistoryElement = ref<typeof SearchHistory>();
const PaypalClient = ref<PayPalNamespace | null>(null);

const UserData = ref<IUserData>({
  Title: '',
  Firstname: '',
  Lastname: '',
  Street: '',
  Housenumber: '',
  PLZ: '',
  Place: '',
  Email: '',
  Phone: '',
  Birthdate: '',
});
const OrderData = ref<IOrderData>({
  code1: '',
  code2: '',
  code3: '',
  carType: ECarType.PKW,
  plateType: EPlateType.Default,
  isSeason: false,
  seasonStart: null,
  seasonEnd: null,
  licensing_office: 1, // change for dev env
  executeReservation: true,
  customerData: {
    title: '',
    firstname: '',
    lastname: '',
    mail: '',
    streetWithNumber: '',
    plz: '',
    place: '',
    phone: '',
    countryCode: '',
    paypalPayerId: '',
  },
});

const InputValid = computed(() => {
  if (Code2.value.length == 0 || Code3.value.length == 0) {
    return false;
  }

  if (Code2.value.length == 1 && Code3.value.length == 1) {
    return false;
  }

  return true;
});
const UserDataValid = computed(() => {
  return (
    UserData.value.Title != '' &&
    UserData.value.Firstname != '' &&
    UserData.value.Lastname != '' &&
    UserData.value.Street != '' &&
    UserData.value.Housenumber != '' &&
    UserData.value.PLZ != '' &&
    UserData.value.Place != '' &&
    UserData.value.Email != '' &&
    UserData.value.Phone != '' &&
    ((UserData.value.Birthdate != '' && UserData.value.Birthdate.length == 10) ||
      OrderData.value.executeReservation == false)
  );
});

onMounted(async () => {
  Office.value = (
    await AxiosClient.post('/GetOfficeDetailsBySlug', {
      slug: useRoute().params.office as string,
    })
  ).data as ILicenseOffice;

  if (localStorage.getItem('SearchHistory-v2') != null) {
    for (const HistoryItem of JSON.parse(
      localStorage.getItem('SearchHistory-v2') as string,
    ) as ISearchResult[]) {
      if (dayjs(HistoryItem.Date).isAfter(dayjs().subtract(7, 'days'))) {
        History.value.push(HistoryItem);
      }
    }
  }

  if (DEBUG_ACTIVE) {
    UserData.value = {
      Title: '1',
      Firstname: 'Test',
      Lastname: 'Test',
      Street: 'Teststr.',
      Housenumber: '12',
      PLZ: '50825',
      Place: 'Köln',
      Email: 'test@outlook.com',
      Phone: '+49 1234 5678',
      Birthdate: '11.11.1911',
    };
    /*setTimeout(() => {
      ActiveStep.value = 4;
    }, 2000);*/
    //  GoToOrderView();
  }
  LoadingActive.value = false;
});

const Search = async () => {
  if (!InputValid.value) {
    return;
  }

  const HistoryItem: ISearchResult = {
    Code1: Code1,
    Code2: Code2.value,
    Code3: Code3.value,
    Available: false,
    Loading: true,
    Date: dayjs().toISOString(),
    CarType: OrderData.value.carType,
    PlateType: OrderData.value.plateType,
    IsSeason: OrderData.value.isSeason,
    SeasonStart: OrderData.value.seasonStart,
    SeasonEnd: OrderData.value.seasonEnd,
  };

  const ExistingItemIndex = History.value.findIndex(
    (x) =>
      x.Code1 == HistoryItem.Code1 &&
      x.Code2 == HistoryItem.Code2 &&
      x.Code3 == HistoryItem.Code3 &&
      x.IsSeason == HistoryItem.IsSeason &&
      x.SeasonStart == HistoryItem.SeasonStart &&
      x.SeasonEnd == HistoryItem.SeasonEnd &&
      x.CarType == HistoryItem.CarType &&
      x.PlateType == HistoryItem.PlateType,
  );
  if (ExistingItemIndex != -1) {
    HistoryItem.Available = History.value[ExistingItemIndex].Available;
    HistoryItem.Loading = false;
    HistoryItem.Date = History.value[ExistingItemIndex].Date;
    // already search
    History.value.splice(ExistingItemIndex, 1);
    History.value.unshift(HistoryItem);

    if (SearchHistoryElement.value && window.innerWidth < 992) {
      SearchHistoryElement.value.$el.children[0].children[0].scrollIntoView({
        block: 'start',
        behavior: 'smooth',
      });
    }
    return;
  }

  History.value.unshift(HistoryItem);

  getCurrentInstance()?.proxy?.$forceUpdate();
  if (SearchHistoryElement.value && window.innerWidth < 992) {
    let TargetElement = SearchHistoryElement.value.$el.children[0];

    if (SearchHistoryElement.value.$el.children[0].children[0]) {
      TargetElement = SearchHistoryElement.value.$el.children[0].children[0];
    }
    TargetElement.scrollIntoView({
      block: 'start',
      behavior: 'smooth',
    });
  }

  const Response = (
    await AxiosClient.post('/CheckAvailabilityAndGetAlternatives', {
      licenseOfficeId: Office.value?.id,
      code1: Code1,
      code2: Code2.value,
      code3: Code3.value,
    })
  ).data as IAvailabilityResponse;

  const ItemIndex = History.value.findIndex(
    (x) =>
      x.Code2 == HistoryItem.Code2 &&
      x.Code3 == HistoryItem.Code3 &&
      x.IsSeason == HistoryItem.IsSeason &&
      x.SeasonStart == HistoryItem.SeasonStart &&
      x.SeasonEnd == HistoryItem.SeasonEnd &&
      x.CarType == HistoryItem.CarType &&
      x.PlateType == HistoryItem.PlateType,
  );

  History.value[ItemIndex].Loading = false;
  if (Response.code === 200) {
    History.value[ItemIndex].Available = true;
  }

  localStorage.setItem(
    'SearchHistory-v2',
    JSON.stringify(History.value.filter((x) => x.Loading == false)),
  );
};

const SelectLicenseForOrder = async (Item: ISearchResult) => {
  if (Item.CarType == ECarType.Trailer) {
    OrderData.value.executeReservation = false;
  } else {
    OrderData.value.executeReservation = true;
  }

  ActiveStep.value = 2;
  if (StepElement.value) {
    StepElement.value.scrollIntoView({
      block: 'start',
      behavior: 'smooth',
    });
  }
  SelectedLicense.value = Item;
  OrderData.value.isSeason = Item.IsSeason;
  OrderData.value.seasonStart = Item.SeasonStart;
  OrderData.value.seasonEnd = Item.SeasonEnd;
  OrderData.value.plateType = Item.PlateType;
  OrderData.value.carType = Item.CarType;
};

const ProceedWithoutReservation = () => {
  if (!InputValid.value) {
    return;
  }
  OrderData.value.executeReservation = false;

  SelectedLicense.value = {
    Code1: Code1,
    Code2: Code2.value,
    Code3: Code3.value,
    Available: false,
    Loading: true,
    Date: dayjs().toISOString(),
    CarType: OrderData.value.carType,
    PlateType: OrderData.value.plateType,
    IsSeason: OrderData.value.isSeason,
    SeasonStart: OrderData.value.seasonStart,
    SeasonEnd: OrderData.value.seasonEnd,
  };

  ActiveStep.value = 2;
  if (StepElement.value) {
    StepElement.value.scrollIntoView({
      block: 'start',
      behavior: 'smooth',
    });
  }
};

const GoBack = (TargetStep: number) => {
  ActiveStep.value = TargetStep;
  if (StepElement.value) {
    StepElement.value.scrollIntoView({
      block: 'start',
      behavior: 'smooth',
    });
  }
};

const GoToOrderView = async () => {
  ActiveStep.value = 3;
  window.scrollTo({ top: (StepElement?.value?.offsetTop || 0) - 200 });

  let ClientID = process.env.VUE_APP_PAYPAL_CLIENT_ID_SANDBOX;
  if (process.env.VUE_APP_PAYPAL_SANDBOX == '0') {
    ClientID = process.env.VUE_APP_PAYPAL_CLIENT_ID;
  }

  PaypalClient.value = await loadScript({
    'client-id': ClientID,
    currency: 'EUR',
    locale: 'de_DE',
    intent: 'authorize',
  });

  if (PaypalClient.value !== null && SelectedLicense.value) {
    await (PaypalClient.value.Buttons as any)({
      createOrder: () => {
        if (SelectedLicense.value && Office.value) {
          OrderData.value.licensing_office = parseInt(Office.value.id);
          OrderData.value.code1 = SelectedLicense.value.Code1.toUpperCase();
          OrderData.value.code2 = SelectedLicense.value.Code2.toUpperCase();
          OrderData.value.code3 = SelectedLicense.value.Code3;
        }
        return AxiosClient.post(`${process.env.VUE_APP_DOMAIN_API}/CreateOrder`, {
          data: OrderData.value,
          userdata: UserData.value,
        }).then((response) => {
          return response.data;
        });
      },
      onApprove: (data: any) => {
        PaypalLoadingActive.value = true;
        OrderID.value = data.orderID;
        return AxiosClient.post(`${process.env.VUE_APP_DOMAIN_API}/CheckOrder`, {
          orderId: data.orderID,
        })
          .then((order) => {
            OrderData.value.customerData.firstname = order.data.payer.name.given_name;
            OrderData.value.customerData.lastname = order.data.payer.name.surname;
            OrderData.value.customerData.mail = order.data.payer.email_address;
            const address = order.data.purchase_units[0].shipping.address;
            OrderData.value.customerData.streetWithNumber = address.address_line_1;
            OrderData.value.customerData.plz = address.postal_code;
            OrderData.value.customerData.place = address.admin_area_2;
            OrderData.value.customerData.countryCode = address.country_code;
            OrderData.value.customerData.paypalPayerId = order.data.payer.payer_id;

            CompleteOrder();
          })
          .catch((err) => {
            alert('Fehler beim Bezahlvorgang');
            console.error('ERROR', err);
          });
      },
      onError: (err: any) => {
        alert('Fehler beim Bezahlvorgang');
        console.error('ERROR', err);
      },
      onCancel: (data: any) => {
        console.log('CANCEL', data);
      },
    }).render('#paypal-button');
  }
};

const CompleteOrder = async (): Promise<void> => {
  PaypalLoadingActive.value = true;
  await AxiosClient.post(
    `${process.env.VUE_APP_DOMAIN_API}/UpdateOrder/${OrderID.value}`,
    OrderData.value.customerData,
  );

  const response = await AxiosClient.get(
    `${process.env.VUE_APP_DOMAIN_API}/CompleteOrder/${OrderID.value}`,
  );

  if (response.data.success === true) {
    location.href = '/bestellabschluss';
    return;
  } else {
    alert('Bei der Reservierung ist ein Fehler aufgetreten: Fehlercode' + response.data.code);
  }
  PaypalLoadingActive.value = false;
};

const OnIsSeasonChange = () => {
  if (OrderData.value.isSeason) {
    OrderData.value.seasonStart = 5;
    OrderData.value.seasonEnd = 11;
  } else {
    OrderData.value.seasonStart = null;
    OrderData.value.seasonEnd = null;
  }
  if (LicenseInputElement.value != null) {
    LicenseInputElement.value.ValidateInput();
  }
};

const OnCarTypeChange = () => {
  if (LicenseInputElement.value != null) {
    LicenseInputElement.value.SetSize();
    LicenseInputElement.value.ValidateInput();
  }
};

const OnPlateTypeChange = () => {
  if (LicenseInputElement.value != null) {
    LicenseInputElement.value.ValidateInput();
  }
};

return (_ctx: any,_cache: any) => {
  const _component_Vue3Lottie = _resolveComponent("Vue3Lottie")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (LoadingActive.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_Vue3Lottie, {
            animationData: _unref(LoadingAnimation),
            height: 150,
            width: 200
          }, null, 8, ["animationData"])
        ]))
      : _createCommentVNode("", true),
    (PaypalLoadingActive.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_Vue3Lottie, {
            animationData: _unref(ReservationAnimation),
            height: 150,
            width: 200
          }, null, 8, ["animationData"]),
          _hoisted_3
        ]))
      : _createCommentVNode("", true),
    (!LoadingActive.value && Office.value)
      ? (_openBlock(), _createBlock(LocationBanner, {
          key: 2,
          Office: Office.value
        }, null, 8, ["Office"]))
      : _createCommentVNode("", true),
    _createElementVNode("section", null, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "location-content",
          ref: (_value, _refs) => {
            _refs['StepElement'] = _value
            StepElement.value = _value
          }
        }, [
          _createVNode(StepHeader, {
            Step: ActiveStep.value,
            onGoBack: _cache[0] || (_cache[0] = ($event: any) => (GoBack($event as any)))
          }, null, 8, ["Step"]),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (ActiveStep.value == 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _hoisted_6,
                    _createElementVNode("div", _hoisted_7, [
                      _hoisted_8,
                      _createVNode(LicenseInput, {
                        Code1: _unref(Code1),
                        OrderData: OrderData.value,
                        Code2: Code2.value,
                        "onUpdate:Code2": _cache[1] || (_cache[1] = ($event: any) => ((Code2).value = $event)),
                        Code3: Code3.value,
                        "onUpdate:Code3": _cache[2] || (_cache[2] = ($event: any) => ((Code3).value = $event)),
                        onEnter: Search,
                        ref: (_value, _refs) => {
                          _refs['LicenseInputElement'] = _value
                          LicenseInputElement.value = _value
                        }
                      }, null, 8, ["Code1", "OrderData", "Code2", "Code3"]),
                      (OrderData.value.carType == _unref(ECarType).Trailer)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createElementVNode("button", {
                              class: "call-to-action-button end",
                              disabled: !_unref(InputValid),
                              onClick: ProceedWithoutReservation
                            }, [
                              _hoisted_11,
                              _createVNode(_component_font_awesome_icon, {
                                style: { color: '#fff' },
                                icon: ['fas', 'cart-shopping']
                              })
                            ], 8, _hoisted_10)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["skip-reservation-button mb-2 mb-md-0", { active: _unref(InputValid) }]),
                              onClick: ProceedWithoutReservation
                            }, " Ohne Reservierung bestellen ", 2),
                            _createElementVNode("button", {
                              class: "call-to-action-button end",
                              disabled: !_unref(InputValid),
                              onClick: Search
                            }, [
                              _hoisted_14,
                              _createVNode(_component_font_awesome_icon, {
                                style: { color: '#fff' },
                                icon: ['fas', 'magnifying-glass']
                              })
                            ], 8, _hoisted_13)
                          ])),
                      _createVNode(InfoBox, { class: "d-none d-lg-block" }, {
                        default: _withCtx(() => [
                          _hoisted_15,
                          _hoisted_16,
                          _hoisted_17,
                          _hoisted_18
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _hoisted_21,
                        _hoisted_22,
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((OrderData.value.carType) = $event)),
                          class: "mb-2",
                          onChange: OnCarTypeChange
                        }, [
                          _createElementVNode("option", {
                            value: _unref(ECarType).PKW,
                            textContent: _toDisplayString(_unref(CarTypeMap)[_unref(ECarType).PKW])
                          }, null, 8, _hoisted_23),
                          _createElementVNode("option", {
                            value: _unref(ECarType).Trailer,
                            textContent: _toDisplayString(_unref(CarTypeMap)[_unref(ECarType).Trailer])
                          }, null, 8, _hoisted_24),
                          _createElementVNode("option", {
                            value: _unref(ECarType).MotorCycle,
                            textContent: _toDisplayString(_unref(CarTypeMap)[_unref(ECarType).MotorCycle])
                          }, null, 8, _hoisted_25)
                        ], 544), [
                          [_vModelSelect, OrderData.value.carType]
                        ]),
                        _hoisted_26,
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((OrderData.value.plateType) = $event)),
                          class: "mb-3",
                          onChange: OnPlateTypeChange
                        }, [
                          _createElementVNode("option", {
                            value: _unref(EPlateType).Default
                          }, "Standard", 8, _hoisted_27),
                          _createElementVNode("option", {
                            value: _unref(EPlateType).OldTimer
                          }, "Oldtimer", 8, _hoisted_28),
                          _createElementVNode("option", {
                            value: _unref(EPlateType).Electric
                          }, "Elektro", 8, _hoisted_29)
                        ], 544), [
                          [_vModelSelect, OrderData.value.plateType]
                        ]),
                        _createVNode(Checkbox, {
                          value: OrderData.value.isSeason,
                          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((OrderData.value.isSeason) = $event)),
                          label: "Saison Kennzeichen",
                          class: "mb-2",
                          onChange: OnIsSeasonChange
                        }, null, 8, ["value"]),
                        (OrderData.value.isSeason)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                              _createElementVNode("div", _hoisted_31, [
                                _createElementVNode("div", _hoisted_32, [
                                  _hoisted_33,
                                  _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((OrderData.value.seasonStart) = $event)),
                                    class: "mb-2"
                                  }, [
                                    _createElementVNode("option", {
                                      value: 1,
                                      textContent: _toDisplayString(_unref(MonthNameMap)[1])
                                    }, null, 8, _hoisted_34),
                                    _createElementVNode("option", {
                                      value: 2,
                                      textContent: _toDisplayString(_unref(MonthNameMap)[2])
                                    }, null, 8, _hoisted_35),
                                    _createElementVNode("option", {
                                      value: 3,
                                      textContent: _toDisplayString(_unref(MonthNameMap)[3])
                                    }, null, 8, _hoisted_36),
                                    _createElementVNode("option", {
                                      value: 4,
                                      textContent: _toDisplayString(_unref(MonthNameMap)[4])
                                    }, null, 8, _hoisted_37),
                                    _createElementVNode("option", {
                                      value: 5,
                                      textContent: _toDisplayString(_unref(MonthNameMap)[5])
                                    }, null, 8, _hoisted_38),
                                    _createElementVNode("option", {
                                      value: 6,
                                      textContent: _toDisplayString(_unref(MonthNameMap)[6])
                                    }, null, 8, _hoisted_39),
                                    _createElementVNode("option", {
                                      value: 7,
                                      textContent: _toDisplayString(_unref(MonthNameMap)[7])
                                    }, null, 8, _hoisted_40),
                                    _createElementVNode("option", {
                                      value: 8,
                                      textContent: _toDisplayString(_unref(MonthNameMap)[8])
                                    }, null, 8, _hoisted_41),
                                    _createElementVNode("option", {
                                      value: 9,
                                      textContent: _toDisplayString(_unref(MonthNameMap)[9])
                                    }, null, 8, _hoisted_42),
                                    _createElementVNode("option", {
                                      value: 10,
                                      textContent: _toDisplayString(_unref(MonthNameMap)[10])
                                    }, null, 8, _hoisted_43),
                                    _createElementVNode("option", {
                                      value: 11,
                                      textContent: _toDisplayString(_unref(MonthNameMap)[11])
                                    }, null, 8, _hoisted_44),
                                    _createElementVNode("option", {
                                      value: 12,
                                      textContent: _toDisplayString(_unref(MonthNameMap)[12])
                                    }, null, 8, _hoisted_45)
                                  ], 512), [
                                    [_vModelSelect, OrderData.value.seasonStart]
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_46, [
                                  _hoisted_47,
                                  _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((OrderData.value.seasonEnd) = $event)),
                                    class: "mb-2"
                                  }, [
                                    _createElementVNode("option", {
                                      value: 1,
                                      textContent: _toDisplayString(_unref(MonthNameMap)[1])
                                    }, null, 8, _hoisted_48),
                                    _createElementVNode("option", {
                                      value: 2,
                                      textContent: _toDisplayString(_unref(MonthNameMap)[2])
                                    }, null, 8, _hoisted_49),
                                    _createElementVNode("option", {
                                      value: 3,
                                      textContent: _toDisplayString(_unref(MonthNameMap)[3])
                                    }, null, 8, _hoisted_50),
                                    _createElementVNode("option", {
                                      value: 4,
                                      textContent: _toDisplayString(_unref(MonthNameMap)[4])
                                    }, null, 8, _hoisted_51),
                                    _createElementVNode("option", {
                                      value: 5,
                                      textContent: _toDisplayString(_unref(MonthNameMap)[5])
                                    }, null, 8, _hoisted_52),
                                    _createElementVNode("option", {
                                      value: 6,
                                      textContent: _toDisplayString(_unref(MonthNameMap)[6])
                                    }, null, 8, _hoisted_53),
                                    _createElementVNode("option", {
                                      value: 7,
                                      textContent: _toDisplayString(_unref(MonthNameMap)[7])
                                    }, null, 8, _hoisted_54),
                                    _createElementVNode("option", {
                                      value: 8,
                                      textContent: _toDisplayString(_unref(MonthNameMap)[8])
                                    }, null, 8, _hoisted_55),
                                    _createElementVNode("option", {
                                      value: 9,
                                      textContent: _toDisplayString(_unref(MonthNameMap)[9])
                                    }, null, 8, _hoisted_56),
                                    _createElementVNode("option", {
                                      value: 10,
                                      textContent: _toDisplayString(_unref(MonthNameMap)[10])
                                    }, null, 8, _hoisted_57),
                                    _createElementVNode("option", {
                                      value: 11,
                                      textContent: _toDisplayString(_unref(MonthNameMap)[11])
                                    }, null, 8, _hoisted_58),
                                    _createElementVNode("option", {
                                      value: 12,
                                      textContent: _toDisplayString(_unref(MonthNameMap)[12])
                                    }, null, 8, _hoisted_59)
                                  ], 512), [
                                    [_vModelSelect, OrderData.value.seasonEnd]
                                  ])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _hoisted_60,
                      _createVNode(SearchHistory, {
                        ref: (_value, _refs) => {
                          _refs['SearchHistoryElement'] = _value
                          SearchHistoryElement.value = _value
                        },
                        History: History.value,
                        onOrder: SelectLicenseForOrder,
                        Code1: _unref(Code1)
                      }, null, 8, ["History", "Code1"]),
                      _createVNode(InfoBox, { class: "d-lg-none mt-4" }, {
                        default: _withCtx(() => [
                          _hoisted_61,
                          _hoisted_62,
                          _hoisted_63,
                          _hoisted_64
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (ActiveStep.value == 2 && Office.value && SelectedLicense.value && UserData.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                    _createElementVNode("div", _hoisted_66, [
                      _hoisted_67,
                      (OrderData.value.executeReservation)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_68, " Ihr Wunschkennzeichen ist verfügbar und kann jetzt von reserviert werden. "))
                        : (_openBlock(), _createElementBlock("p", _hoisted_69, "Ihr Wunschkennzeichen wird nicht reserviert.")),
                      _createElementVNode("div", _hoisted_70, [
                        _createVNode(LicenseDisplay, { License: SelectedLicense.value }, null, 8, ["License"])
                      ]),
                      (OrderData.value.executeReservation)
                        ? (_openBlock(), _createBlock(InfoBox, { key: 2 }, {
                            default: _withCtx(() => [
                              _hoisted_71,
                              _hoisted_72,
                              _hoisted_73
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(InfoBox, { key: 3 }, {
                            default: _withCtx(() => [
                              _hoisted_74,
                              _hoisted_75,
                              _hoisted_76
                            ]),
                            _: 1
                          }))
                    ]),
                    _createVNode(CustomerDataInput, {
                      LicenseOffice: Office.value,
                      UserData: UserData.value,
                      "onUpdate:UserData": _cache[8] || (_cache[8] = ($event: any) => ((UserData).value = $event)),
                      OrderData: OrderData.value
                    }, null, 8, ["LicenseOffice", "UserData", "OrderData"]),
                    _createElementVNode("div", _hoisted_77, [
                      _createElementVNode("div", _hoisted_78, [
                        _createElementVNode("div", _hoisted_79, [
                          _createElementVNode("button", {
                            class: "back-button mb-4 mb-md-0",
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (GoBack(1)))
                          }, "Zurück"),
                          _createElementVNode("button", {
                            disabled: !_unref(UserDataValid),
                            class: "call-to-action-button",
                            onClick: GoToOrderView
                          }, [
                            _hoisted_81,
                            _createVNode(_component_font_awesome_icon, {
                              style: { color: '#fff' },
                              icon: ['fas', 'arrow-right']
                            })
                          ], 8, _hoisted_80)
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (ActiveStep.value == 3 && Office.value && SelectedLicense.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                    _createElementVNode("div", _hoisted_83, [
                      (OrderData.value.executeReservation)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_84, " Schritt 3: Zahlung und Reservieren "))
                        : (_openBlock(), _createElementBlock("div", _hoisted_85, "Schritt 3: Zahlung")),
                      (OrderData.value.executeReservation)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_86, [
                            _createTextVNode(" Sie können nun im folgenden Ihr Wunschkennzeichen direkt bei der Zulassungsstelle " + _toDisplayString(Office.value.Name) + " reserieren und direkt 2 Kennzeichen bestellen. Der Versand erfolgt noch am ", 1),
                            _hoisted_87,
                            _hoisted_88
                          ]))
                        : (_openBlock(), _createElementBlock("p", _hoisted_89, _hoisted_93)),
                      _createElementVNode("div", _hoisted_94, [
                        _createVNode(LicenseDisplay, {
                          License: SelectedLicense.value,
                          OrderData: OrderData.value
                        }, null, 8, ["License", "OrderData"])
                      ]),
                      _hoisted_95,
                      _createVNode(CostTable, { License: SelectedLicense.value }, null, 8, ["License"]),
                      _hoisted_96,
                      _createVNode(UserDataTable, { UserData: UserData.value }, null, 8, ["UserData"]),
                      _createElementVNode("div", _hoisted_97, [
                        _createElementVNode("button", {
                          class: "back-button",
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (GoBack(2)))
                        }, "Zurück zur Dateneingabe")
                      ]),
                      _createVNode(InfoBox, { class: "mt-4" }, {
                        default: _withCtx(() => [
                          _hoisted_98,
                          _hoisted_99,
                          _hoisted_100,
                          _hoisted_101,
                          _hoisted_102,
                          _hoisted_103,
                          _hoisted_104,
                          _hoisted_105,
                          _hoisted_106
                        ]),
                        _: 1
                      })
                    ]),
                    _hoisted_107
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ], 512)
      ])
    ]),
    _createElementVNode("section", _hoisted_108, [
      _createElementVNode("div", _hoisted_109, [
        _createVNode(StepBox),
        _createVNode(CopyText)
      ])
    ])
  ], 64))
}
}

})